import React from "react";
import "./features.css";

const FeatureSection = ({
  id,
  title,
  subtitle,
  points,
  image,
  reverse = false,
  badge,
}) => {
  return (
    <section
      id={id}
      className={`feature-section ${reverse ? "reverse-section" : ""}`}
    >
      <div className="container">
        <div className="feature-row">
          <div className="feature-content  order-2 order-md-1">
            {badge && <span className="feature-badge">{badge}</span>}

            <h2 className="feature-title">{title}</h2>
            <p className="feature-subtitle">{subtitle}</p>

            <ul className="feature-points">
              {points.map((point, idx) => (
                <li key={idx} className="feature-point ">
                  <span className="feature-check">✓</span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            {/* <button className="feature-btn">Explore Feature →</button> */}
          </div>

          <div className="feature-image-col  order-1 order-md-2">
            <div className="feature-image-frame">
              <img src={image} alt={title} className="feature-img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
